import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useState } from "react";
import * as yup from "yup";

import { Input } from "../../../components/Input/input";
import { StyledButton } from "../../../components/Button/button";

import { ForgottenPasswordRequestBody } from "../../../services/account/forgotten-password-send-mail/types";
import { forgottenPasswordSendMail } from "../../../services/account/forgotten-password-send-mail";

import { Description, FormHeading, FormWrapper } from "./styles";
//import { WrongEmailBox } from "./wrong-email-box";

import { LayoutAccount } from "../../../components/layoutAccount";
import { url } from "../../../utils/url";
import { LoadingBackDrop } from "../../../components/loader";
import React from "react";

export const ForgottenPasswordSendMail = () => {
  let navigate = useNavigate();

  const [isEmailInBase, setIsEmailInBase] = useState(true);
  const [isQuestionSent, setIsQuestionSent] = useState(false);
  const forgottenPasswordSendMailMutation = useMutation(
    forgottenPasswordSendMail,
    {
      onSuccess: (res) => {
        setIsQuestionSent(true);
        if (res.data.error_code === 0) {
          navigate(url.thankYouPage);
          setIsEmailInBase(true);

        } else {
          setIsEmailInBase(false);
          navigate(url.thankYouPage);
        }
      },
      onError: (err) => {
        setIsQuestionSent(false);
      },
    }
  );

  const validationSchema = yup.object({
    email: yup
      .string()
      .required("E-mail jest wymagany")
      .email("Wpisz poprawny adres E-mail.")
      .max(50, "Za długi E-mail."),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values: ForgottenPasswordRequestBody) => {
      handleSubmitSendEmail(values);
    },
  });

  const handleSubmitSendEmail = (body: ForgottenPasswordRequestBody) => {
    forgottenPasswordSendMailMutation.mutate(body);
  };
  if (forgottenPasswordSendMailMutation.isLoading) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <LayoutAccount>
      <form onSubmit={formik.handleSubmit}>
        <FormWrapper>
          <FormHeading>Odzyskaj hasło</FormHeading>
          <Description>
            Podaj adress E-mail, którego używasz do obsługi konta. Na podany
            adres otrzymasz link do ustawienia nowego hasła.
          </Description>
          <Input
            label="E-mail"
            id="email"
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            onBlur={formik.handleBlur}
            variant="filled"
            style={{ marginTop: 11 }}
          />
          <StyledButton
            type="submit"
            variant="contained"
            disabled={Boolean(formik.errors.email)}
          >
            Wyślij
          </StyledButton>
          {/* {isQuestionSent ?
                            !isEmailInBase ? < WrongEmailBox type={'error'} /> : < WrongEmailBox type={'success'} />
                            : ""} */}
        </FormWrapper>
      </form>
    </LayoutAccount>
  );
};
